/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-empty */
import React, { useEffect, useState } from 'react'
import BackButton from '../../../components/Button/BackButton'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../../redux/actions'
import { Link, useParams, useHistory } from 'react-router-dom'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import dayjs from 'dayjs'
import moment from 'moment'
// components
import { Box, Button, Stack } from '@chakra-ui/react'
import SpinnerLoading from 'components/Loading/SpinnerLoading'
import ChartRenderingComponent from '../../../components/Graphs/Functions/ChartRendering'
//import SearchGraph from './SearchGraph'

// ! ตอนนี้กราฟ จะ Rander ได้เฉพาะข้อมูลที่เป็น Number ยังไม่สามารถ Rerender จากข้อมูลที่เป็น Boolean ได้
export default function OneGraphDisplay({ sidebarStatus, setIsShowSidebar }) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [currentGroup, setcurrentGroup] = useState()
  const [isFetchNewOne, setisFetchNewOne] = useState(true)
  const [isFirstTime, setIsFirstTime] = useState(true)
  const dispatch = useDispatch()
  const params = useParams()
  const currentStation = useSelector((state) => state.station)
  const allLogs = useSelector((state) => state.log)
  //const allPredictionLogs = useSelector((state) => state.logPrediction)
  const [graphMin, setGraphMin] = useState(undefined)
  const [graphMax, setGraphMax] = useState(undefined)
  const [tickAmount, setTickAmount] = useState(8)
  const [valueFormat, setValueFormat] = useState('HH:mm')
  const me = useSelector((state) => state.me)
  const history = useHistory()
  const [selectGraph, setSelectGraph] = useState()

  console.log('page of oneGraphDisplay')

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(actions.stationGet(params.stationId))
        setisFetchNewOne(false)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData() // เรียกใช้งานฟังก์ชัน async ที่สร้างขึ้น

    return () => {}
  }, [params.stationId, isFetchNewOne])

  useEffect(() => {
    let timeOut
    const fetchLog = async () => {
      try {
        if (params.stationId) {
          console.log('Fetching the log Firsttime or not', isFirstTime)
          if (isFirstTime === true) {
            dispatch(
              actions.logOnDaySpecific(
                params.stationId,
                dayjs().toDate(),
                dayjs().toDate(),
                'log1mm'
              )
            ).then(() => {
              timeOut = setTimeout(() => {
                setIsLoading(true)
              }, 1000)
            })
          } else {
            dispatch(
              actions.logOnDaySpecific(
                params.stationId,
                dayjs().toDate(),
                dayjs().toDate(),
                'log1mm'
              )
            )
          }
        }
      } catch (error) {
        console.error('Error fetching station data:', error)
      }
    }

    fetchLog()
    return () => {
      if (timeOut) {
        clearTimeout(timeOut)
      }
    }
  }, [isFetchNewOne, params.stationId])

  // // ? เราจำเป็นต้อง Fetch ค่าจากทุุกสถานีมาก่อน แล้วค่อยใช้ Use State แบ่งเอา
  // // เพราะเราต้องโชว์ใน Sidebar ทุกอัน
  useEffect(() => {
    const og = []
    if (currentStation) {
      _.map(currentStation?.charts, (chartS) => {
        if (chartS?.chartSensorRef === params.sensorRef) {
          setSelectGraph(chartS)
        }
      })
      //  console.log('priGauge', og)
    }
    return () => {}
  }, [params, isFetchNewOne])
  // //console.log('GG', priority, priGauge)

  useEffect(() => {
    if (isFetchNewOne === false) {
      setTimeout(() => {
        setisFetchNewOne(true)
      }, 60000)
      //ปรับกราฟใหม่ ทุกๆ 60 วินาที
    }
    return () => {}
  }, [isFetchNewOne])

  const lastHour = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1mm')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }

  const lastDay = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1h')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }

  const lastWeek = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1d')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }

  const lastMonth = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1d')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }

  return isLoading && currentStation ? (
    <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
      <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div className="flex flex-wrap items-center">
          <div className="relative w-full max-w-full flex-grow flex-1">
            <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans ">
              {t('dashboard.dashboardMonitor')}
            </h6>
            <h2 className="text-gray-800 text-2xl font-bold font-sans">
              {t('dashboard.graph')} {currentStation.name}
            </h2>
          </div>
        </div>
        <Button>
          <BackButton />
        </Button>
      </div>

      {/* <div className="flex justify-between p-4">
        <h2 className="text-gray-800 text-xl px-10 font-bold font-sans">
          กลุ่ม {currentGroup?.groupName}
        </h2>
        <SearchGraph
          data={Sg} //ข้อมูลทั้งหมด
          setData={setGraphSelect} // เซ็ต temp data ให้เหลือเท่าที่กรอง
        />
     
      </div> */}

      {selectGraph !== undefined ? (
        <div className={`p-4 w-full`}>
          <ChartRenderingComponent
            multichart={false}
            key={selectGraph?._id}
            chartData={selectGraph}
            data={allLogs}
            graphMax={graphMax}
            graphMin={graphMin}
            setGraphMax={setGraphMax}
            setGraphMin={setGraphMin}
            setTickAmount={setTickAmount}
            setValueFormat={setValueFormat}
            tickAmount={tickAmount}
            valueFormat={valueFormat}
            stationData={currentStation}
            enableTimeSelect={true}
          />
          <Stack direction={['column', 'row']} spacing={['2', '4']}>
            <Button
              size="sm"
              onClick={() => {
                lastHour()
                setGraphMin(undefined)
                setGraphMax(undefined)
                // setGraphMin(moment().subtract('hours').toDate().getTime())
                // setGraphMax(moment().ad('hours').toDate().getTime())

                setTickAmount(10)
                setValueFormat('HH:mm')
              }}
            >
              {t('graph.hourAgo')}
            </Button>
            <Button
              size="sm"
              onClick={() => {
                setGraphMin(moment().subtract(1, 'days').toDate().getTime())
                setGraphMax(moment().add(2, 'hours').toDate().getTime())
                setIsLoading(false)
                lastDay()
                setTickAmount(12)
                setValueFormat('HH:mm')
              }}
            >
              {t('graph.dayAgo')}
            </Button>
            <Button
              size="sm"
              onClick={() => {
                setGraphMin(moment().subtract(1, 'weeks').toDate().getTime())
                setGraphMax(moment().add(1, 'days').toDate().getTime())
                setIsLoading(false)
                lastWeek()
                setTickAmount(7)
                setValueFormat('DD MMM YYYY')
              }}
            >
              {t('graph.weekAgo')}
            </Button>
            <Button
              size="sm"
              onClick={() => {
                setGraphMin(moment().subtract(1, 'months').toDate().getTime())
                setGraphMax(moment().add(2, 'days').toDate().getTime())
                setIsLoading(false)
                setTickAmount(6)
                lastMonth()
                setValueFormat('DD MMM YYYY')
              }}
            >
              {t('graph.monthAgo')}
            </Button>
          </Stack>
        </div>
      ) : (
        <div className={`p-4 w-full jusitfy-center text-lg `}>
          ไม่มีกราฟท่านต้องการ โปรดตรวจสอบชื่อ Sensor : {`${params.sensorRef}`}{' '}
          อีกครั้ง
        </div>
      )}
    </div>
  ) : (
    <SpinnerLoading />
  )
}
